import MedicareTool from '~components/MedicareTools/MedicareToolsButton';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

const ZipWithDrugAndDoctor = () => {
    return (
        <section className="hero-paid-search-zip-with-drug-doctor">
            <div className="bg-surface-light md:bg-transparent p-4 md:p-0 mt-0 lg:mt-6 rounded-lg drop-shadow-elevation-shadow-overlay md:filter-none flex justify-center">
                <div className="max-w-screen-xs md:max-w-screen-xl w-full">
                    <div className="mb-6 md:mb-2 lg:mb-6">
                        <ZipForm
                            buttonTitle="Compare Plans"
                            buttonWaLink="Hero Drug Doctor: Compare Plan"
                            qaValue="Hero Drug Doctor"
                            opts={{
                                btnStyle: 'primary',
                                useWideLayout: true,
                            }}
                        />
                    </div>

                    <div className="">
                        <p className="text-center md:text-left">
                            Add doctors or medications to view plans that match your needs.
                        </p>
                        <div className="grid grid-cols-3 lg:grid-cols-6 gap-4 my-6">
                            <div className="col-span-3">
                                <MedicareTool
                                    buttontype="secondary"
                                    btnWidth="w-full md:max-lg:max-w-72"
                                    trackingName="Hero Drug Doctor"
                                    toolname="doctor"
                                    label="Add doctors"
                                    fontSize="text-xl"
                                />
                            </div>
                            <div className="col-span-3">
                                <MedicareTool
                                    buttontype="secondary"
                                    btnWidth="w-full md:max-lg:max-w-72"
                                    trackingName="Hero Drug Doctor"
                                    toolname="drug"
                                    label="Add my Rx drugs"
                                    fontSize="text-xl"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ZipWithDrugAndDoctor;
